import TextInput from "../../common/TextInput";

function AxisMajorMinorStepComponent({ major, minor, Dyn, onChange, axis = "X" }) {
    function getLoc(str) {
        return Dyn.loc(str);
    }

    const majorStepKey = axis + "majorstep";
    const minorStepKey = axis + "minorstep";

    return (
        <div className="tde-numeric-range-component" style={{ display: "flex" }}>
            <div className="tde-row tde-mr-2">
                <div className="tde-mb-2">{getLoc("Major Step")}</div>
                <TextInput
                    value={major}
                    ariaLabel={"Major Step"}
                    onChange={(value) => onChange(value, majorStepKey)}
                />
            </div>
            <div className="tde-row tde-ml-2">
                <div className="tde-mb-2">{getLoc("Minor Step")}</div>
                <TextInput
                    value={minor}
                    ariaLabel={"Minor Step"}
                    onChange={(value) => onChange(value, minorStepKey)}
                />
            </div>
        </div>
    );
}

export default AxisMajorMinorStepComponent;
